module.exports = __webpack_public_path__ + "static/media/background-banner_escuro.74710bdc.jpg";